import { useState } from 'react';

import Link from 'next/link';

import CategoriesMenu from './CategoriesList';

import * as S from './styles';

export default function NavigationTree() {
  const [showBrandsUltra, setShowBrandsUltra] = useState(false);

  return (
    <S.Container className="header-navigation-tree">
      <div className="header-navigation-tree-content">
        <CategoriesMenu />

        <ul className="header-tags">
          {/* <li className="header-tags-ultra-compare">
            <a href="/ultracompare">
              <img
                src="/images/ultra-compare-logo.svg"
                alt="Ultra Compare"
                className="ultra-compare-image"
              />
            </a>
          </li> */}
          <li className="header-tags-sidney-oliveira-club">
            <a href="/clube-sidney-oliveira">
              <img
                src="/images/clube-sidney-oliveira-logo.svg"
                alt="Clube Sidney Oliveira"
                className="clube-sidney-oliveira-image"
              />
            </a>
          </li>
        </ul>

        <div className="header-navigation-tree-info">
          <a
            href="https://atendimento.ultrafarma.com.br/hc/pt-br"
            className="header-navigation-tree-info-group"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Atendimento ao Cliente (SAC)</span>
          </a>

          <Link href="/central-do-cliente/pedidos">
            <a className="header-navigation-tree-info-group">
              <span>Acompanhar pedido</span>
            </a>
          </Link>

          <div
            className={`brands-group-ultra ${showBrandsUltra ? 'show' : ''}`}
          >
            <span onClick={() => setShowBrandsUltra(state => !state)}>
              Marcas do Grupo
            </span>

            {showBrandsUltra && (
              <div className="all-brands-group-ultra">
                <a href="https://www.ultrafarma.com.br/" target="_blank">
                  <img
                    src="/images/brands-group-ultra/ultrafarma.png"
                    alt="Ultrafarma"
                  />
                </a>
                <a href="https://www.oticasultrafarma.com.br/" target="_blank">
                  <img
                    src="/images/brands-group-ultra/oticas-ultrafarma.png"
                    alt="Óticas Ultrafarma"
                  />
                </a>
                <a href="https://www.ultratakado.com/" target="_blank">
                  <img
                    src="/images/brands-group-ultra/ultratakado.png"
                    alt="Ultratakado"
                  />
                </a>
              </div>
            )}
          </div>

          {/* <div className="header-navigation-tree-info-download-app-info">
            <span>Baixe o App:</span>

            <ul className="header-navigation-tree-info-download-app">
              <li>
                <a
                  href="https://apps.apple.com/br/app/ultrafarma-t%C3%A1-no-seu-cora%C3%A7%C3%A3o/id1501710955?utm_content=appstore"
                  target="_blank"
                >
                  <img src="/images/selos/app-apple.svg" alt="App Apple" />
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=br.com.ultrafarma.app"
                  target="_blank"
                >
                  <img src="/images/selos/app-google.svg" alt="App Google" />
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </S.Container>
  );
}
